import Alert from '@mui/material/Alert';
import React from 'react';
import { previewPrFromDomain } from 'components/common/previewEnv';

/**
 * Shown on per-PR preview web hosts (pr-<N>.preview.ommnio.com).
 * APP_DOMAIN is baked at build time by webpack.
 */
const PreviewBanner = () => {
  const pr = previewPrFromDomain(process.env.APP_DOMAIN || '');
  if (!pr) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0, height: 'auto', flexShrink: 0 }}
      data-testid="preview-banner"
    >
      PREVIEW pr-{pr} — not production. Data is shared staging.
    </Alert>
  );
};

export default PreviewBanner;
